// Nhãn + màu cho mã kết quả quét (khớp enum WarehouseScanResult ở backend).
export const RESULT_META = {
  READY: { label: "Hợp lệ — chờ xác nhận", variant: "success" },
  SUCCESS: { label: "Đã xác nhận", variant: "primary" },
  REMOVED: { label: "Đã bỏ", variant: "secondary" },
  ALREADY_IN: { label: "Đã ở Kho VN", variant: "warning" },
  DUPLICATE: { label: "Quét trùng", variant: "warning" },
  NOT_FOUND: { label: "Không tồn tại", variant: "secondary" },
  WRONG_STATUS: { label: "Sai trạng thái", variant: "danger" },
  WRONG_CUSTOMER: { label: "Sai khách hàng", variant: "danger" },
  NOT_READY: { label: "Chưa đến Kho VN", variant: "danger" },
  AMBIGUOUS: { label: "Mã trùng nhiều đơn", variant: "danger" },
  NO_SESSION: { label: "Hết phiên", variant: "danger" },
  UNCLAIMED_CREATED: { label: "Tạo Đơn vô chủ", variant: "info" },
  NETWORK: { label: "Lỗi kết nối", variant: "danger" },
};

export const resultMeta = (result) => RESULT_META[result] || { label: result || "-", variant: "secondary" };

const sum = (counts, keys) => keys.reduce((total, key) => total + (counts[key] || 0), 0);

/** Thống kê theo BRD §6 — đếm theo bước kiểm tra, cộng số mã đã xác nhận. */
export function buildStats(scanType, counts, total, confirmedCount = 0) {
  if (scanType === "IN") {
    return [
      { label: "Tổng đã quét", value: total, variant: "primary" },
      { label: "Hợp lệ", value: sum(counts, ["READY"]), variant: "success" },
      { label: "Lỗi", value: sum(counts, ["WRONG_STATUS", "AMBIGUOUS", "NO_SESSION"]), variant: "danger" },
      { label: "Chưa tồn tại", value: sum(counts, ["NOT_FOUND"]), variant: "secondary" },
      { label: "Quét trùng", value: sum(counts, ["DUPLICATE", "ALREADY_IN"]), variant: "warning" },
      { label: "Đã xác nhận", value: confirmedCount, variant: "primary" },
    ];
  }
  return [
    { label: "Tổng đã quét", value: total, variant: "primary" },
    { label: "Đúng KH", value: sum(counts, ["READY"]), variant: "success" },
    { label: "Sai KH", value: sum(counts, ["WRONG_CUSTOMER"]), variant: "danger" },
    { label: "Lỗi", value: sum(counts, ["NOT_FOUND", "NOT_READY", "WRONG_STATUS", "AMBIGUOUS", "NO_SESSION"]), variant: "danger" },
    { label: "Quét trùng", value: sum(counts, ["DUPLICATE"]), variant: "warning" },
    { label: "Đã xác nhận", value: confirmedCount, variant: "primary" },
  ];
}
